import React, { useEffect, useState } from "react"; 
import { useNavigate, useParams } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { JWT_VAl } from "./Functions/jwt_validate";
import Header from "../Component/Header";
import { createCookie, deleteCookie, getCookie } from "../CookieFunctions";
import { apihost, authhost,basehost } from "../ApiHost";

const LoginWithPayPal = () => {
    document.title="InsightNest | Payment Page";
    const { planId } = useParams();
    const [paymentFailed, setPaymentFailed] = useState(false);
    const navigate = useNavigate();
    
    useEffect(() => {
        async function s() {
            const JWT = await JWT_VAl();
            if (!JWT.success && !JWT.verified) {
                localStorage.setItem("loginRedirect", `${basehost}/payment/${planId}`);
                window.location.href = authhost;
            }
            if (planId !== "pro" && planId !== "premium" && planId !== "starter") {
                navigate("/");
            }
        }
        s();
    },[navigate, planId]);
    // Fetch Order ID from Backend
    const createOrder = async () => {
        console.log(planId);
        try {
            const response = await fetch(`${apihost}/payment/create-payment`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getCookie("_JWT")}`,
                },
                body: JSON.stringify({planId}), // Add your payload
            });
            // console.log(await response.json());
            const data = await response.json();
            console.log(data);
            return data.id; // Return the orderID for PayPal
        } catch (error) {
            console.error("Error creating order:", error);
            alert("Failed to create PayPal order.");
        }
    };

    return (
        <>
        <Header/>
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-10">
            <div className="w-full max-w-4xl flex flex-col md:flex-row items-center bg-white shadow-lg rounded-lg overflow-hidden">
                
                {/* Left Section: Information */}
                <div className="w-full md:w-1/2 p-8 bg-gradient-to-r from-blue-500 to-indigo-600 text-white flex flex-col justify-center">
                    <h2 className="text[black] font-semibold leading-tight mb-4">
                        Complete Your Payment
                    </h2>
                    <h2 className="text[black] font-semibold leading-tight mb-4">
                        Amount : <b>${planId === "pro" ? 10 : planId === "premium" ? 15 : 5}</b>
                    </h2>
                    <p className="text[black] mb-6">
                        You're about to purchase the <strong>{planId}</strong> plan which gives you <strong> {planId==="pro"? 10:planId==="premium"?16:4} credits</strong>.
                    </p>
                </div>

                {/* Right Section: PayPal Button */}
                <div className="w-full md:w-1/2 p-8 flex flex-col items-center justify-center bg-white">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
                        Pay with PayPal
                    </h2>
                    {paymentFailed && (
                    <p className="text-sm text-[#ff0000] mb-8 text-center">
                       Payment failed. Please try again. if the problem persists, contact support.
                    </p>
                    )}
                    <PayPalScriptProvider
                        options={{
                            "client-id": "ATzzySiB83D7x2ZRdlZkzNAJK8Cy76g9frA-P-4xcz5A6ZDY-9kejE0znOQn98p76i42ZnxEuy05WJL6",
                            components: "buttons",
                        }}
                    >
                        <PayPalButtons

                            createOrder={async (data, actions) => {
                                return await createOrder();
                            }}
                            onApprove={async (data, actions) => {
                               const response=await fetch(
                                    `${apihost}/payment/execute-payment`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${getCookie("_JWT")}`,
                                    },
                                    body: JSON.stringify({
                                        token: data.orderID,
                                        planId,
                                    }),
                                });
                                if(response.ok){
                                    let re=localStorage.getItem("payment_redirect");
                                    if(re){
                                        localStorage.removeItem("payment_redirect");
                                        navigate(re);
                                    }else{
                                        navigate("/");
                                    }
                                }else{
                                    setPaymentFailed(true);
                                }
                            }}
                            onError={(err) => {
                                console.error("PayPal Checkout error:", err);
                                setPaymentFailed(true);
                                // alert("Payment failed. Please try again.");
                            }}
                        />
                    </PayPalScriptProvider>
                </div>
            </div>
        </div>
        </>
    );
};

export default LoginWithPayPal;
